import { ValuesOf } from 'shared'

export const LANDING_PAGE_VARIANTS = {
    Default: 'default',
    Meta: 'meta',
} as const

export type ILandingPageVariant = ValuesOf<typeof LANDING_PAGE_VARIANTS>

export const deriveLpVariantFromPath = (pathname: string): ILandingPageVariant => {
    if (pathname.startsWith('/meta/') || pathname.startsWith('/products/')) return LANDING_PAGE_VARIANTS.Meta
    return LANDING_PAGE_VARIANTS.Default
}
